import React from "react";

export const SectionTitle = ({title}) => {
    return <div className='section-title w-100 d-flex align-items-center my-3'>
            <p className="p-2 secondary-inverse--bg onsecondary-inverse--color secondary-font" style={{borderRadius:'1rem', fontSize:'1.5em'}}>{title}</p>
            <div className="flex-grow-1 secondary-inverse--bg" style={{height:2}}></div>
    </div>
}
